import { render, staticRenderFns } from "./Subparceiro.vue?vue&type=template&id=5787d512&"
import script from "./Subparceiro.vue?vue&type=script&lang=js&"
export * from "./Subparceiro.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports